import Dialoguemodal from 'components/dialoguemodal'
import CreateTeam from 'layouts/admin/team/create-team'
import React, { useState } from 'react'

function Edit({ user, updateList, idx }) {
  const [open, setOpen] = useState(false)

  const handleFormClose = (updates) => {
    setOpen(false)
    updateList(updates, idx)
  }
  return (
    <>
      <span
        onClick={() => setOpen(true)}
        class="tw-text-medium tw-text-navyBlue hover:tw-cursor-pointer tw-undefined"
      >
        Edit
      </span>
      <Dialoguemodal open={open} onClose={() => setOpen(false)}>
        <CreateTeam user={user} onClose={handleFormClose} />
      </Dialoguemodal>
    </>
  )
}

export default Edit
